import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '../theme';
import { isolateMixin } from '../utils/mixins';

var styles = function styles(theme) {
  return {
    sideNavItem: {
      extend: isolateMixin,
      fontFamily: theme.fontFamily,
      display: 'flex',
      alignItems: 'center',
      userSelect: 'none',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      position: 'relative',
      textDecoration: 'none',
      fontSize: theme.sideNav.fontSize,
      height: theme.sideNav.height,
      color: theme.sideNav.colors.default.text,
      transition: 'color .2s',
      'a&:visited': {
        color: theme.sideNav.colors.default.text
      },
      '&&$isSelected, &&:hover': {
        color: theme.sideNav.colors.selected.text
      }
    },
    icon: {
      flex: 'none',
      display: 'inline-block',
      width: '1em',
      height: '1em',
      fontSize: theme.sideNav.iconSize
    },
    isSelected: {
      cursor: 'default'
    },
    medium: {
      '& $icon': {
        marginRight: theme.sideNav.iconRightMargin
      }
    }
  };
};

var _ref = /*#__PURE__*/React.createElement("div", null);

var SideNavItem = /*#__PURE__*/function (_Component) {
  _inherits(SideNavItem, _Component);

  var _super = _createSuper(SideNavItem);

  function SideNavItem() {
    var _this;

    _classCallCheck(this, SideNavItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onClick = function (event) {
      var _this$props = _this.props,
          value = _this$props.value,
          onClick = _this$props.onClick,
          onPress = _this$props.onPress;
      if (onPress) onPress(event, value);
      if (onClick) onClick(event);
    };

    return _this;
  }

  _createClass(SideNavItem, [{
    key: "renderIcon",
    value: function renderIcon(icon) {
      if (icon) {
        var classes = this.props.classes;
        return cloneElement(icon, _extends({
          color: 'currentColor',
          size: null
        }, icon.props, {
          className: classnames(icon.props.className, classes.icon)
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          icon = _this$props2.icon,
          size = _this$props2.size,
          isSelected = _this$props2.isSelected,
          container = _this$props2.container,
          classes = _this$props2.classes,
          theme = _this$props2.theme,
          onPress = _this$props2.onPress,
          value = _this$props2.value,
          other = _objectWithoutProperties(_this$props2, ["className", "children", "icon", "size", "isSelected", "container", "classes", "theme", "onPress", "value"]);

      var mediumSize = size === 'medium';
      var resultClassName = classnames(classes.sideNavItem, className, mediumSize && classes.medium, isSelected && classes.isSelected);
      var resultContainer = isValidElement(container) ? container : typeof container === 'function' ? container({
        activeClassName: classes.isSelected
      }) : _ref;

      var resultProps = _extends({}, other, {
        className: resultClassName,
        onClick: this.onClick
      });

      return cloneElement(resultContainer, resultProps, this.renderIcon(icon), mediumSize && children);
    }
  }]);

  return SideNavItem;
}(Component);

SideNavItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Css-класс компонента
   */
  className: PropTypes.string,

  /**
   * Стили перелючателя
   */
  style: PropTypes.object,

  /**
   * Контент
   */
  children: PropTypes.node,

  /**
   * Иконка
   */
  icon: PropTypes.node.isRequired,

  /**
   * Размер компонента (автоматически проставляется компонентом `<SideNav />`)
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Значение, соответствующее этому элементу
   */
  value: PropTypes.any,

  /**
   * Выбран ли элемент (автоматически проставляется компонентом `<SideNav />`)
   */
  isSelected: PropTypes.bool,

  /**
   * Элемент, который содержит контент, например `<Link />` в случае с `react-router`, или `<a />` если необходима ссылка.
   * Если используется `<NavLink />` с `activeClassName`,
   * нужно в `container` передавать фабрику, которая получает `activeClassName` в аргументах
   */
  container: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),

  /**
   * Колбек нажатия на элемент (автоматически проставляется компонентом `<SideNav />`)
   */
  onPress: PropTypes.func,

  /**
   * Коллбек клика на элемент, в качестве аргументов принимает объект события
   */
  onClick: PropTypes.func
} : {};
export default withStyles(styles, {
  name: 'SideNavItem'
})(SideNavItem);